import FeatureToggler from './directives/FeatureToggler';

export default angular.module('edge.platform.featuredetection', []).directive('gwFeatureToggler', FeatureToggler);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-featuredetection-angular/module.js
// module id = 1349
// module chunks = 0